import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import type { TSlots } from 'shared/types/TDelivery';

import { DELIVERY_FORM_FIELDS } from '../constants';

import { getMeetingDate } from './mapSlots';
import { transformSlotsToMeetings } from './transformSlotsToMeetings';

export const useSlots = (allSlots: TSlots['slots']) => {
  const { setValue, getValues } = useFormContext();

  const slots = transformSlotsToMeetings(allSlots || []);

  const dateValue = getValues(DELIVERY_FORM_FIELDS.DATE_SLOT);

  useEffect(() => {
    if (!dateValue) {
      setValue(DELIVERY_FORM_FIELDS.DATE_SLOT, slots[0]?.date);
      setValue(DELIVERY_FORM_FIELDS.TIME_SLOT, slots[0]?.intervals?.[0]?.slotId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateValue, setValue, slots[0]?.date]);

  const dateSlots = slots?.map(({ date }) => ({ label: getMeetingDate(date), id: date, value: date })) || [];
  const timeSlots =
    slots
      ?.find(({ date }) => date === dateValue)
      ?.intervals?.map(({ slotId, timeFrom, timeTo }) => ({
        id: slotId,
        value: slotId,
        label: `с ${timeFrom} до ${timeTo}`,
      })) || [];

  return {
    slots,
    dateSlots,
    timeSlots,
  };
};
